export default "__VITE_ASSET__CkIHN72r__"